module.exports = __webpack_public_path__ + "img/placeholder_wireframe.f8ceff93.svg";